import { IStep } from '../../../interface/concretes/step.interface';
import { LayoutInfo } from './layout-info.model';

export class Step implements IStep {
  private _layoutInfo: LayoutInfo;
  private _url: string;
  private _isActive: boolean;
  private _isCompleted: boolean;
  private _isAutomatic: boolean;

  constructor(
    layoutInfo: LayoutInfo,
    url: string,
    isActive: boolean,
    isCompleted: boolean,
    isAutomatic: boolean
  ) {
    this._layoutInfo = layoutInfo;
    this._url = url;
    this._isActive = isActive;
    this._isCompleted = isCompleted;
    this._isAutomatic = isAutomatic;
  }

  get layoutInfo(): LayoutInfo {
    return this._layoutInfo;
  }

  get url(): string {
    return this._url;
  }

  get isActive(): boolean {
    return this._isActive;
  }

  get isCompleted(): boolean {
    return this._isCompleted;
  }

  get isAutomatic(): boolean {
    return this._isAutomatic;
  }

  set layoutInfo(value: LayoutInfo) {
    this._layoutInfo = value;
  }

  set url(value: string) {
    this._url = value;
  }

  set isActive(value: boolean) {
    this._isActive = value;
  }

  set isCompleted(value: boolean) {
    this._isCompleted = value;
  }

  set isAutomatic(value: boolean) {
    this._isAutomatic = value;
  }
}
